import { render } from "./MainListSales.vue?vue&type=template&id=e5e3acce&scoped=true"
import script from "./MainListSales.vue?vue&type=script&lang=js"
export * from "./MainListSales.vue?vue&type=script&lang=js"

import "./MainListSales.vue?vue&type=style&index=0&id=e5e3acce&scoped=true&lang=css"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5e3acce"]])

export default __exports__